import { lockedServiceUtils } from 'utilities/LockedServiceUtils';

import { cacheMethodResult } from '../../utilities/cacheMethodResult';

define((require, exports, module) => {
    'use strict';

    const inherit = require('inherit');
    const Emitter = require('Emitter');

    const Service = inherit(Emitter, {
        name: 'abstract',

        serviceAvailabilityFeatureName: '',

        _subscribers: [],

        constructor: function Service(params) {
            Service.parent.call(this);

            this._serviceState = params.serviceState;
        },

        set(attrs) {
            const wasActivated = this.isActivated();

            this._serviceState.set(attrs);

            const isActivated = this.isActivated();

            if (!wasActivated && isActivated) {
                this._onResetModelInstance();

                if (this._onLoadFinish) {
                    this._onLoadFinish();
                }
            }
        },

        getModel() {
            return this._serviceState.getModelInstance();
        },

        _onResetModelInstance() {
            // an optional hook can be defined in a concrete service
            // FIXME: remove this hook if possible - it seems to expose internal logic,
            // or maybe use some higher-level one, like `onServiceActivated`
            // start with storing some instance even if a service is inactive,
            if (this._onSetModelInstance) {
                this._onSetModelInstance(this.getModel());
            }

            this.getModel().on('change', () => {
                this.emit('change', this.getModel());
            });
            setTimeout(() => this.emit('change', this.getModel()), 0);
        },

        isActivated() {
            return this._serviceState.serviceIsActive();
        },

        isLocked() {
            return this.isFrozen() || this.isSuspended();
        },

        isFrozen() {
            let result = false;
            const model = this._serviceState.getModelInstance();
            if (model) {
                result = model.get('status') === 'FROZEN';
            }
            return result;
        },

        isSuspended() {
            let result = false;
            const model = this._serviceState.getModelInstance();
            if (model) {
                result = model.get('status') === 'SUSPENDED';
            }
            return result;
        },

        getSuspendDate() {
            let result = false;
            const model = this._serviceState.getModelInstance();
            const suspendTime = 2592000;
            if (model) {
                const date = new Date(
                    (model.get('suspended_at') + suspendTime) * 1000,
                );
                result = lockedServiceUtils.getFormattedDate(date);
            }
            return result;
        },

        isProtected() {
            let result = false;
            const model = this._serviceState.getModelInstance();
            if (model) {
                result = model.get('protected');
            }
            return result;
        },

        load: cacheMethodResult({
            target() {
                return this._serviceState
                    .load()
                    .then(({ newModelInstanceCreated }) => {
                        if (newModelInstanceCreated) {
                            this._onResetModelInstance();
                        }

                        if (this._onLoadFinish) {
                            return this._onLoadFinish();
                        }
                    });
            },
        }),

        // FIXME: remove this - outer code should not know anything about internal state, including its validity
        forceReload() {
            this.load._invalidateCache();
            this._serviceState.resetCache();
            return this.load();
        },

        getServiceState() {
            return this._serviceState;
        },
    });

    module.exports = Service;
});
